import { useEffect, useRef, useState } from 'react';

const useIntersectionObserver = ( ref ) => {
  const [ isOnScreen, setIsOnScreen ] = useState( false );
  const [ position, setPosition ] = useState( false );

  const observerRef = useRef( null );

  const callback = ( entry ) => {
    setIsOnScreen( entry.isIntersecting );
    setPosition( entry.boundingClientRect.top < 0 );
  };

  useEffect( () => {
    if ( !ref?.current ) return;

    observerRef.current = new IntersectionObserver( ( [ entry ] ) => callback( entry ) );
    observerRef.current.observe( ref.current );

    return () => {
      observerRef.current?.disconnect();
    };
  }, [ ref ] );

  return [ isOnScreen, position ];
};

export default useIntersectionObserver;
